import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=38bb4c9d&scoped=true"
import script from "./preview.vue?vue&type=script&lang=ts"
export * from "./preview.vue?vue&type=script&lang=ts"
import style0 from "./preview.vue?vue&type=style&index=0&id=38bb4c9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_3bbe12a2a332147dfeceaba3e069e538/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bb4c9d",
  null
  
)

export default component.exports